export const singleResultInitialState = {
    item: {},
    loading: false
};

const formatterFuncDefault = (entity) => {
    return entity;
};

export function singleResultReducer(state = singleResultInitialState, ACTION, action, formatter = formatterFuncDefault) {
    switch (action.type) {
        case ACTION.REQUEST:
            return {
                ...singleResultInitialState,
                loading: true
            };

        case ACTION.SUCCESS:
            return {
                ...state,
                item: formatter(action.payload),
                loading: false
            };
        case ACTION.FAILURE:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }

}



// WEBPACK FOOTER //
// ./src/js/reducers/common/single-result.js